import { DoctorModel } from '@/types/models/doctors';
import InputEntity, { PHONE_MASK } from '@/lib/formFactory/inputEntity';
import CheckboxEntity from '@/lib/formFactory/checkboxEntity';
import ImageEntity from '@/lib/formFactory/imageEntity';
import MultiSelectEntity from '@/lib/formFactory/multiselect/entity';

export default class EntityModel {
    model: DoctorModel;

    constructor() {
        const surname = new InputEntity('surname');
        surname.setTitle('Фамилия');
        surname.setRequired(true);
        
        const name = new InputEntity('name');
        name.setTitle('Имя');
        name.setRequired(true);
        
        const patronymic = new InputEntity('patronymic');
        patronymic.setTitle('Отчество');
        patronymic.setRequired(true);
        
        const description = new InputEntity('description');
        description.setTitle('Описание');
        description.setRequired(true);
        description.setSize(1000);
        
        const email = new InputEntity('email');
        email.setTitle('Email');
        email.setRequired(true);

        const phone = new InputEntity('phone');
        phone.setTitle('Телефон');
        phone.setRequired(true);
        phone.setMask(PHONE_MASK);

        const clinics = new MultiSelectEntity('clinics')
            .setTitle('Клиники')
            .setListLoader({
                moduleName: 'clinics/'
            })
        
        const careerStart = new InputEntity('careerStart');
        careerStart.setTitle('Дата начала стажа');
        careerStart.setMask({
            inputFormat: 'dd.mm.yyyy',
            outputFormat: 'dd.mm.yyyy',
            placeholder: 'дд.мм.гггг',
            alias: 'datetime'
        });
        careerStart.setRequired(true);
        
        const photo = new ImageEntity('photo');
        photo.setTitle('Фотография');
        photo.setKey('photo-input');
        photo.setRequired(true);
        
        const haveDegree = new CheckboxEntity('haveDegree');
        haveDegree.setName('Ученая степень');

        const password = new InputEntity('password');
        password.setTitle('Пароль');

        const repeatPassword = new InputEntity('repeatPassword');
        repeatPassword.setTitle('Подтвердите пароль');
        
        const availableTypes = new CheckboxEntity('isActive');
        availableTypes.setName('Активен');
        availableTypes.setList([]);

        this.model = {
            name: name.entity[name.entityName],
            surname: surname.entity[surname.entityName],
            patronymic: patronymic.entity[patronymic.entityName],
            email: email.entity[email.entityName],
            phone: phone.entity[phone.entityName],
            description: description.entity[description.entityName],
            clinics: clinics.entity,
            careerStart: careerStart.entity[careerStart.entityName],
            haveDegree: haveDegree.entity,
            city: {},
            photo: photo.entity[photo.entityName],
            password: password.entity[password.entityName],
            repeatPassword: repeatPassword.entity[repeatPassword.entityName],
            availableTypes: availableTypes.entity,
        };
    }
}
